import { OmniIconComponent, OmniTooltipNextComponent } from "../../../../../shared";

export default function CampaignDetailsCard({
  dateRange,
  campaignName,
  syntheticId,
  clientCode,
  productCode,
  orderedData,
  toggleCampaignDetailModal
}) {

  return (
    <>
      <div className="campaign-details-card-v2">
        <div className="campaign-details-card-header">
          <OmniTooltipNextComponent style={{ width: "fit-content", maxWidth: "80%" }}>
            <div slot="invoker" className="campaign-details-card-title" title={campaignName}>
              {campaignName}
            </div>
            <div slot="content">{campaignName}</div>
          </OmniTooltipNextComponent>
          <div className="campaign-details-card-info-icon" onClick={toggleCampaignDetailModal}>
            <OmniIconComponent className="is-size-2" icon-id="omni:informative:info" />
          </div>
        </div>
        <div className="campaign-details-card-content">
          <div className="campaign-details-card-item">
            <span className="campaign-details-card-label">Date Range</span>
            <span className="campaign-details-card-value">{dateRange || '-'}</span>
          </div>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="1" height="24" viewBox="0 0 1 24" fill="none">
              <rect y="24" width="24" height="1" transform="rotate(-90 0 24)" fill="#CFD2D7"/>
            </svg>
          </div>
          <div className="campaign-details-card-item">
            <span className="campaign-details-card-label">ID</span>
            <span className="campaign-details-card-value">{syntheticId || '-'}</span>
          </div>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="1" height="24" viewBox="0 0 1 24" fill="none">
              <rect y="24" width="24" height="1" transform="rotate(-90 0 24)" fill="#CFD2D7"/>
            </svg>
          </div>
          <div className="campaign-details-card-item">
            <span className="campaign-details-card-label">Client Code</span>
            <span className="campaign-details-card-value">{clientCode || '-'}</span>
          </div>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="1" height="24" viewBox="0 0 1 24" fill="none">
              <rect y="24" width="24" height="1" transform="rotate(-90 0 24)" fill="#CFD2D7"/>
            </svg>
          </div>
          <div className="campaign-details-card-item">
            <span className="campaign-details-card-label">Product Code</span>
            <span className="campaign-details-card-value">{productCode || '-'}</span>
          </div>
        </div>
      </div>
      <div className="campaign-stat-card">
        <div className="campaign-stat-card-content">
          <OmniIconComponent className="campaign-stat-icon" icon-id="omni:object:creative" />
          <span className="campaign-stat-label">Creatives</span>
        </div>
        <div className="campaign-stat-value">{orderedData?.total_creatives || 0}</div>
      </div>
      <div className="campaign-stat-card">
        <div className="campaign-stat-card-content">
          <OmniIconComponent className="campaign-stat-icon" icon-id="omni:informative:cart" />
          <span className="campaign-stat-label">Placements</span>
          <OmniTooltipNextComponent style={{ width: "fit-content", maxWidth: "80%" }}>
            <OmniIconComponent slot="invoker" className="campaign-stat-info-icon" icon-id="omni:informative:error" />
            <div slot="content">have been created across all media orders for this campaign, including placements that aren't synced with Prisma.</div>
          </OmniTooltipNextComponent>
        </div>
        <div className="campaign-stat-card-right">
          <div className="campaign-stat-value">{orderedData?.total_placement_count || 0}</div>
          {/* <OmniIconComponent className="campaign-stat-chevron" icon-id="omni:interactive:right" /> */}
        </div>
      </div>
    </>
  );
};
